import React, { useEffect, useState } from 'react';
import './ListaCategoria.css';
import baseURL from '../url';
import backgroundCatalog from '../../images/background_catalog.png';
import { FaTshirt, FaSwimmer, FaFan, FaUserAlt, FaMale, FaRegGrinStars, FaQuestion, FaUmbrellaBeach, FaRegSmile, FaRegSnowflake, FaRegSun } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

// Mapeo de iconos por nombre de categoría usando solo iconos existentes y representativos
const iconMap = {
    'Tanga': <FaUserAlt />, // Persona
    'Bikini': <FaUmbrellaBeach />, // Playa
    'Briefs': <FaMale />, // Masculino
    'Tank top': <FaTshirt />, // Camiseta
    'T-Shirt': <FaTshirt />, // Camiseta
    'Swimwear': <FaSwimmer />, // Natación
    'Shorts': <FaRegSmile />, // Casual/divertido
    'Abanicos': <FaFan />, // Ventilador/abanico
};

const ListaCategoria = ({ isCompact = false, currentCategoryId = null, logo }) => {
    const [categorias, setCategorias] = useState([]);
    const [loading, setLoading] = useState(true);
    const [storeName, setStoreName] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${baseURL}/categoriasConPreciosGet.php`)
            .then(res => res.json())
            .then(data => {
                if (data.categorias) {
                    setCategorias(data.categorias);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error cargando categorías:', error);
                setLoading(false);
            });
        
        // Obtener nombre de la tienda
        fetch(`${baseURL}/contactoGet.php`)
            .then(res => res.json())
            .then(data => {
                if (data.contacto && data.contacto.length > 0) {
                    setStoreName(data.contacto[0].nombre || '');
                }
            });
    }, []);

    if (loading) return <div className="lc-loading">Cargando categorías...</div>;

    // Definir el background con la imagen importada y los gradientes encima, ahora más transparentes
    const containerStyle = {
        backgroundImage: `
            linear-gradient(135deg, rgba(255,255,255,0.7) 60%, color-mix(in srgb, var(--color1) 12%, #d8d8d8) 100%),
            radial-gradient(ellipse at 60% 0%, rgba(255,255,255,0.3) 0%, transparent 60%),
            url(${backgroundCatalog})
        `,
        backgroundSize: 'cover, cover, cover',
        backgroundRepeat: 'no-repeat, no-repeat, no-repeat',
        backgroundPosition: 'center, center, center',
    };

    // Función para renderizar el contenido de la categoría (imagen o icono)
    const renderCategoryContent = (cat) => {
        if (cat.imagen) {
            return (
                <img 
                    src={cat.imagen} 
                    alt={`Imagen de ${cat.categoria}`}
                    className="lc-category-image"
                    onError={(e) => {
                        // Si la imagen falla, mostrar el icono por defecto
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                    }}
                />
            );
        }
        return (
            <div className="lc-icon">
                {iconMap[cat.categoria] || <FaQuestion />}
            </div>
        );
    };

    // Si es compacto, mostrar una versión simplificada
    if (isCompact) {
        return (
            <div className="lc-container-compact" style={containerStyle}>
                <div className="lc-header-compact">
                    <h2 className="lc-title-compact">Explora otras categorías</h2>
                    <p className="lc-subtitle-compact">¿Te gustaría ver más productos?</p>
                </div>
                <div className="lc-grid-compact">
                    {categorias
                        .filter(cat => cat.idCategoria !== currentCategoryId) // Excluir la categoría actual
                        .slice(0, 6) // Mostrar máximo 6 categorías
                        .map((cat, idx) => (
                            <div
                                className="lc-card-compact"
                                key={cat.categoria + cat.precio_minimo}
                                onClick={() => window.location.href = `/productos?idCategoria=${cat.idCategoria}`}
                                tabIndex={0}
                                role="button"
                                aria-label={`Ver productos de ${cat.categoria}`}
                            >
                                {renderCategoryContent(cat)}
                                {/* Icono de respaldo (oculto por defecto si hay imagen) */}
                                {cat.imagen && (
                                    <div className="lc-icon" style={{ display: 'none' }}>
                                        {iconMap[cat.categoria] || <FaQuestion />}
                                    </div>
                                )}
                                <div className="lc-cat-name-compact">{cat.categoria}</div>
                                <div className="lc-price-compact">
                                    <span className="lc-desde">Desde</span> ${cat.precio_minimo}
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        );
    }

    return (
        <div className="lc-container" style={containerStyle}>
            <div className="lc-header">
                <div className="lc-store-name">{storeName}</div>
                                            <img src={logo} alt="Logo tienda" className="lc-logo" />
                <h1 className="lc-title">Nuestro Catálogo</h1>
                <p className="lc-subtitle">Selecciona la categoría que te interesa</p>
            </div>
            <div className="lc-separator"></div>
            <div className="lc-grid">
                {categorias.map((cat, idx) => (
                    <div
                        className="lc-card"
                        key={cat.categoria + cat.precio_minimo}
                        onClick={() => window.location.href = `/productos?idCategoria=${cat.idCategoria}`}
                        tabIndex={0}
                        role="button"
                        aria-label={`Ver productos de ${cat.categoria}`}
                    >
                        {renderCategoryContent(cat)}
                        {/* Icono de respaldo (oculto por defecto si hay imagen) */}
                        {cat.imagen && (
                            <div className="lc-icon" style={{ display: 'none' }}>
                                {iconMap[cat.categoria] || <FaQuestion />}
                            </div>
                        )}
                        <div className="lc-cat-name">{cat.categoria}</div>
                        <div className="lc-price">
                            <span className="lc-desde">Desde</span> ${cat.precio_minimo}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ListaCategoria; 